<template>
  <div id="pageCourseList" class="container">
    <v-container class="mx-auto" fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex sm12>
          <v-row align="center">
            <v-col lg="8" md="8" sm="6">
              <h2>Dashboard</h2>
            </v-col>
            <v-col lg="4" md="4" sm="6">
              <v-select
                v-model="dateRange"
                :items="dateRanges"
                dense
                item-text="rangeLabel"
                item-value="id"
                label="Select"
                outlined
                persistent-hint
                prepend-icon="event"
                return-object
                single-line
              ></v-select>
            </v-col>
          </v-row>
        </v-flex>
        <div class="d-flex justify-center" style="width: 100%">
          <v-flex xs12 lg10 id="dash-container">
            <v-divider />
            <v-flex lg4 md4 sm4 xs12>
              <question-mini-statistic
                :date-range="this.dateRange.id"
                :type="null"
                color="indigo"
                icon="event_note"
                sub-title="Resolvidas"
              >
              </question-mini-statistic>
            </v-flex>
            <v-flex lg4 md4 sm4 xs12>
              <question-mini-statistic
                :date-range="this.dateRange.id"
                :type="1"
                color="green"
                icon="event_available"
                sub-title="Acertos"
              >
              </question-mini-statistic>
            </v-flex>
            <v-flex lg4 md4 sm4 xs12>
              <question-mini-statistic
                :date-range="this.dateRange.id"
                :type="0"
                color="red"
                icon="event_busy"
                sub-title="Erros"
              >
              </question-mini-statistic>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <lesson-line-chart
                :date-range="this.dateRange.id"
                color="red"
                icon="event_busy"
                title="Aulas assistidas"
                type="bar"
              >
              </lesson-line-chart>
            </v-flex>
            <v-flex v-for="e in this.enrollments" :key="e.id" lg6 sm12 xl4 xs12>
              <topic-box-radar-chart
                :course-id="e.course.id"
                :title="e.course.course"
              >
              </topic-box-radar-chart>
            </v-flex>

            <v-flex lg6 md6 sm6 xs12>
              <grade-circle
                color="primary"
                icon="setting"
                sub-text="Last 24 Hours"
                caption="Baseado nos últimos"
                :date-range="this.dateRange.id"
              />
            </v-flex>
          </v-flex>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import CircleStatistic from "../../components/widgets/statistic/CircleStatistic";
import LinearStatistic from "../../components/widgets/statistic/LinearStatistic";
import MiniStatistic from "../../components/widgets/statistic/MiniStatistic";
import QuestionMiniStatistic from "../../components/widgets/dashboard/QuestionMiniStatistic";
import LessonLineChart from "../../components/widgets/dashboard/LessonLineChart";
import EnrollmentService from "../../services/enrollments.service";
import TopicBoxRadarChart from "../../components/widgets/chart/TopicBoxRadarChart";
import Util from "@/util";
import GradeCircle from "../../components/widgets/dashboard/GradeCircle";

export default {
  components: {
    GradeCircle,
    TopicBoxRadarChart,
    LessonLineChart,
    QuestionMiniStatistic,
    MiniStatistic,
    LinearStatistic,
    CircleStatistic,
  },
  data() {
    return {
      enrollments: null,
      dateRanges: Util.defaultDateRanges(),
      dateRange: "currentWeek",
    };
  },
  computed: {
    isOffline() {
      if (!navigator) return false;
      return !navigator.onLine;
    },
  },
  mounted() {
    // this.loadCourses()
    if (this.isOffline) {
      window.getApp.sendSnackMessage(
        "Você está offline, não é possivel acessar essa página",
        "error",
      );
      return;
    }
  },
  methods: {
    loadCourses() {
      EnrollmentService.getMyCourses()
        .then((response) => {
          this.enrollments = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#dash-container {
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
}
</style>
